import React, { useEffect, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import useInput from "../hooks/useInput";
import { deleteExchange, getExchanges, getUserExchangeAccounts, submitSelectedAccount, updateTransactionFee } from "../../actions/setting-action";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import useLoading from "../hooks/useLoading";
import Loading from "../common/Loading";

const ConnectedExchangeCard = (props)=>{
    const {exchange,updateTransactionFee,getExchanges,deleteExchange,t,getUserExchangeAccounts,submitSelectedAccount} = props
    const dropdownRef = useRef(null)
    const [openMenu, setOpenMenu] = useState(false);
    const [openEditFee, setopenEditFee] = useState(false);
    const [showAccountPopup, setShowAccountPopup] = useState(false);
    const [feeUnit, setFeeUnit] = useState(exchange.transaction_fee.unit?exchange.transaction_fee.unit:"net");
    const [fee, setFee] = useInput(exchange.transaction_fee.fee?exchange.transaction_fee.fee:"" || "");
    const [deleteId, setDeleteId] = useState(0);
    const userAccounts = useSelector((state) => state.settings.userAccounts) || [];
    const [selectedAccountId, setSelectedAccountId] = useState(null);
    const [selectedExchangeId, setSelectedExchangeId] = useState(null);
    const [setLoading, bindLoading] = useLoading();
    const handleClickOutside = (event) => {
        // Check if the click is outside of any bot's menu or button
        if (!dropdownRef.current || dropdownRef.current.contains(event.target)) {
        return;
        }
        else{
        setOpenMenu(false)
        }
    };
    useEffect(() => {
        setOpenMenu(false)
    },[openEditFee])
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const clickSubmit = ()=>{
         let param = { name: "transaction_fee",value: exchange.id,value2:feeUnit,value3:fee}
         updateTransactionFee(param).then((res)=>{
             getExchanges()
             toast.success("updated")
         })
     }
     const clickDelete = () => {
        deleteExchange(deleteId);
        setDeleteId(0);
      };
     const showAccounts = (exchangeId,refresh) => {
        if(refresh){
            setLoading(true);
        }
        setShowAccountPopup(true);
        setSelectedExchangeId(exchangeId);
        getUserExchangeAccounts({
            exchange_id:exchangeId,
            refresh:refresh?1:0
        }).then((res)=>{
            setLoading(false);
            if(refresh)
            toast.success(t('acc-refres-succ'))
        }).catch((err)=>{
            setLoading(false);
        });
      };
     const selectAccount = (accountId) => {
        setSelectedAccountId(accountId);
      };
     const clickSubmitSelectedAccount = () => {
        setLoading(true);
        submitSelectedAccount({
            id:selectedAccountId
        }).then((res)=>{
            setLoading(false);
            toast.success(t('acc-selec-succ'))
        }).catch((err)=>{
            setLoading(false);
        });
      };
      useEffect(() => {
        // Set the default active account on the first render
        const defaultActive = userAccounts?.find(item => item.active === 1);
        if (defaultActive) {
            setSelectedAccountId(defaultActive.id);
        }
    }, [userAccounts]);
      
      const accounts = userAccounts && userAccounts.map((item,index)=>{
        let usdBalance = 0;
        let balancesRow = [];
        if (item.balances) {
            const balancesArray = JSON.parse(item.balances);
            // Find the balance for USD
            usdBalance = balancesArray.find(balance => balance.coin === "USD")?.free || 0;
            const positiveBalances = balancesArray.filter(balance => balance.free >= 0);

            balancesRow = positiveBalances.map(balance => (
                <li key={balance.coin}>
                    {balance.coin}: {balance.free}
                </li>
            ));
        }
        return (
           
            <li key={index} className={`account-item ${selectedAccountId === item.id ? 'active' : ''}`} onClick={()=>selectAccount(item.id)}>
                    {/* <a>{item.account_id} <br></br> Balance : ${usdBalance}</a> */}
                    <a>Account ID : {item.account_id} <br></br></a>

                    <ul className="acc-balance-show">{balancesRow}</ul>
            </li>
        )
    })
    return(
        <div className="col-xl-4 col-md-6">
					<div className="main-dna-cart main-brokerage-cart">
						<div className="dna-cart-header">
							<ul>
								<li>
									<img src={exchange.image} alt="icon" width={20}/>
									<h6>{exchange.name}</h6>
								</li>
								<li>
									<div className="dropdown" ref={dropdownRef}>
										<i className="fa-solid fa-ellipsis-vertical" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" onClick={()=>setOpenMenu(exchange.id)}></i>
										<ul className={`dropdown-menu ${openMenu==exchange.id?"show":""} dna-cart-dropdown connected-exchange`} aria-labelledby="dropdownMenuButton1">
											  
											<li onClick={()=>setopenEditFee(true)}>
												<a className="dropdown-item pointer"  >
													<img src="/images/se-cart-icon2.png" alt=""/>
													Edit Fee
												</a>
											</li>
											<li onClick={()=>showAccounts(exchange.id)}>
												<a className="dropdown-item pointer"  >
													<img src="/images/c-details-icon.png" alt=""/>
													{t('connect-account')}
												</a>
											</li>
											<li>
												<a className="dropdown-item" href="#" onClick={() => {
                            setDeleteId(exchange.id);
                          }}>
													<img src="/images/se-cart-icon3.png" alt=""/>
													Delete
												</a>
											</li>
											{/* <div className="dna-cart-dropdown-footer">
												<span>Active</span>
												<div className="check-box">
													<input type="checkbox" checked/>
												</div>
											</div> */}
										</ul>
									</div>
								</li>
							</ul>
						</div>
						<div className="dna-cart-body">
							<span>API Key </span>
							<p>{exchange.id==16?"********************":exchange.api_key}</p>
                            <span>Transaction Fee</span>
                            <p>{fee}{feeUnit=="net"?"$":"%"}</p>
                            <button className="blue-button small" onClick={() => showAccounts(exchange.id)}>
                              {t("connect-account")}
                            </button>
						</div>
						{openEditFee ? <div className="dna-footer brokerage-cart-footer">
							<span>Transaction Fee </span>
							<div>
								<select onChange={(e) => setFeeUnit(e.target.value)}>
                                    <option value="net">$</option>
                                    <option value={'percentage'}>%</option>
								</select>
								<input type="number" {...setFee}/>
								<button onClick={()=>clickSubmit()}>Submit</button>
							</div>
						</div>:<></>}
					</div>
                    <Modal show={deleteId > 0} onHide={() => setDeleteId(0)}>
                        <Modal.Header closeButton>
                        <Modal.Title>{t("warning")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        {t("delete-api-warning")}
                        </Modal.Body>
                        <Modal.Footer>
                        <button className="blue-button" onClick={clickDelete}>
                            {t("delete")}
                        </button>
                        </Modal.Footer>
                    </Modal>
                    <Loading {...bindLoading}>
                    <Modal show={showAccountPopup} onHide={() => setShowAccountPopup(false)}>
                        <Modal.Header closeButton>
                        <Modal.Title><h2>{t("please-chose-acc")}</h2></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        
                        <div class="account-list-container">
                            
                            <ul class="account-list">
                               {accounts}
                            </ul>
                        </div>
                        </Modal.Body>
                        <div className="d-flex justify-content-between modal-footer-div">
                        <button className="blue-button" onClick={()=>showAccounts(selectedExchangeId,true)}>
                            {t("Refresh")} &nbsp; <i class="fa-solid fa-arrows-rotate"></i>
                        </button>
                        <button className="blue-button" onClick={()=>clickSubmitSelectedAccount()}>
                            {t("submit")}
                        </button>
                        </div>
                    </Modal>
                    </Loading>
				</div>
    )
}

export default connect(null,{updateTransactionFee,getExchanges,deleteExchange,getUserExchangeAccounts,submitSelectedAccount})(ConnectedExchangeCard)
